





































































































































































































import "./goal.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import ObjectiveCard from "../components/goals/objective-card.vue";
import ObjectiveSetup from "../components/goals/objective-setup.vue";
import ObjectiveCopy from "../components/goals/objective-copy.vue";
import TrackingFilter from "../components/goals/tracking-filter.vue";
import ReportCard from "../components/goals/report-card.vue";
import MemberList from "../components/goals/member-list.vue";
import AssignmentList from "../components/assignments/assignment-list.vue";
import AssignmentTrackerFilter from "../components/assignments/assignment-tracker-filter.vue";
import VideoPlayer from "../components/video-player/video-player.vue";
import BottomNavigation from "../components/common/bottom-navigation/bottom-navigation.vue";
import BottomNavigationItem from "../components/common/bottom-navigation/bottom-navigation-item.vue";
import ResizableTextarea from "../components/common/ResizableTextarea.js";
import GoalSetup from "../components/goals/goal-setup.vue";

export default Vue.extend({
  components: {
    ObjectiveCard,
    ObjectiveSetup,
    ObjectiveCopy,
    MemberList,
    TrackingFilter,
    AssignmentList,
    "assignment-tracking-filter": AssignmentTrackerFilter,
    VideoPlayer,
    ReportCard,
    BottomNavigation,
    BottomNavigationItem,
    ResizableTextarea,
    GoalSetup,
  },
  props: {
    id: String,
  },
  data() {
    return {
      isCollapsed: false,
      hoverCollapseToggled: false,
      lastMenuItemName: "dashboard",
      currentMenuItemName: "dashboard",
      showGoalSetup: false,
      edittingGoal: {
        id: null,
        name: null,
        scope: null,
        timezoneOffset: NaN,
        timezoneName: null,
        timeline: null,
        description: null,
        members: [],
        hashTags: null,
        grantedPermissions: [],
        gradeModel: null,
        calculationOption: NaN,
        completed: false,
        teams: [],
      },
      showQuickEditor: false,
      quickEdittingObjective: null,
      quickEdittingObjectiveName: "",
      quickEditorStyles: {},
      showObjectiveCreatorOld: false,
      showObjectiveSetup: false,
      showObjectiveCopy: false,
      showDelete: false,
      copyingObjective: null,
      edittingObjective: {
        id: null,
        name: null,
        timeline: null,
        priority: NaN,
        maxPriority: NaN,
        description: null,
        trackingQuestion: null,
        measurementUnit: null,
        targetType: 1,
        inputOptions: null,
        trackingTarget: null,
        checkinDates: null,
        checkinTime: "09:00",
        cronExcludedDates: [],
        cronExpression: null,
        cronStartDate: null,
        cronEndDate: null,
        attachments: [],
        goalId: null,
      },
      currentObjectiveId: null,
      deleteElement: null,
      checkpoints: [],
      trackColumns: [],
      trackData: [],
      currentTrackerId: null,
      reportCardValueFormat: "both",
      viewType: null,
      showVideoPlayer: false,
      videoUrl: "",
      userId: 1,
      name: "Test",
      email: "test@gmail.com",
      phone: 111-111-1111,
    };
  },
  computed: {
    ...mapState("goal", ["currentGoal", "loading", "currentActionTrackingInformation", "currentGoalHasCheckpointUpdated"]),
    ...mapGetters("goal", ["canEditCurrentGoal", "currentGoalGrades"]),
    ...mapState("session", ["user"]),
    allObjectives(): any {
      let objectives = (this as any).currentGoal ? (this as any).currentGoal.objectives || [] : [];
      return objectives.sort((a, b) => {
        return a.priority === b.priority ? 0 : a.priority > b.priority ? 1 : -1;
      });
    },
    notStartedObjectives(): any {
      return this.allObjectives ? this.allObjectives.filter((objective) => isNaN(objective.trackingResult)) : [];
    },
    gradedLists() {
      let context = this as any;
      let lists = (this as any).currentGoalGrades.map((grade, index, grades) => {
        return {
          title: grade.name,
          color: grade.color,
          from: grade.from,
          to: index < grades.length - 1 ? grades[index + 1].from : NaN,
          objectives: [],
        };
      });

      lists.forEach((list) => {
        list.objectives = context.allObjectives.filter((objective) => objective.trackingResult * 100 >= list.from && (isNaN(list.to) ? true : objective.trackingResult * 100 < list.to));
      });

      return lists;
    },
    goalForAssignmentsAndReport() {
      let currentGoal = (this as any).currentGoal;
      return currentGoal && {}.toString.call(currentGoal) === "[object Function]" ? null : currentGoal;
    },
    menuitemClasses: function () {
      return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
    },
  },
  watch: {
    id(value) {
      this.loadGoal();
    },
    user(newValue) {
      if (newValue) {
        (this as any).selectedMemberId = newValue.id;
 
        (this as any).$intercom.boot({
          user_id: (this as any).user.id,
          user_hash: (this as any).user.intercomUserHash,
          name: (this as any).user.name,
          email: (this as any).user.emailAddress,
          phone: (this as any).user.phoneNumber,
        });
        (this as any).$intercom.show();
      }
    },
    email(email) {
      (this as any).$intercom.update({ email });
    },
  },
  mounted() {
    let context = this as any;

    context.loadGoal().then(() => {
      let tab = context.$route.query.tab;
      if (tab) {
        context.handleMenuSelect(tab);
      }
    });

    abp.event.on("abp.notifications.received", context.handleNotificationReceived);
  },
  created() {
    let context = this as any;
    context.$store.dispatch("goal/setTargetUserFilter", context.currentGoalTrackingMembers && context.currentGoalTrackingMembers.length > 0 ? "0" : null);
  },
  beforeDestroy() {
    let context = this as any;
    console.log("leave page");
    abp.event.off("abp.notifications.received", context.handleNotificationReceived);
  },
  methods: {
    handleMenuSelect(name) {
      this.currentMenuItemName = name;
      //this.$store.dispatch("goal/setActiveMenu", name);

      if (name === "checkins") {
        this.handleRefreshAssignments();
      }

      this.lastMenuItemName = name;
    },
    loadGoal() {
      let context = this as any;
      return this.$store.dispatch("goal/get", { id: context.id }).then((response) => {
        context.handleReportCardFilter();
      });
    },
    handleNotificationReceived(userNotification) {
      console.log(userNotification);
      if (userNotification.notification.entityId === this.id && userNotification.notification.data.version > (this as any).currentGoal.contentVersion) {
        this.loadGoal();
      }
    },
    handleMenuItemClick(name) {
      let context = this as any;
      switch (name) {
        case "editGoal":
          context.handleOpenGoalEditor(context.currentGoal);
          break;
      }
    },
    handleOpenGoalEditor(goal) {
      let startDate = goal.startDate ? new Date(goal.startDate) : null;
      let endDate = goal.endDate ? new Date(goal.endDate) : null;

      this.edittingGoal = {
        id: goal.id,
        name: goal.name,
        scope: goal.scope,
        timezoneOffset: goal.timezoneOffset,
        timezoneName: goal.timezoneName,
        timeline: [startDate, endDate],
        description: goal.description,
        members: goal.members,
        hashTags: goal.hashTags,
        grantedPermissions: goal.grantedPermissions,
        gradeModel: goal.gradeModel,
        calculationOption: goal.calculationOption,
        completed: goal.completed,
        teams: goal.teams,
      };

      this.showGoalSetup = true;
    },
    handleCancelNewGoal() {
      this.showGoalSetup = false;
    },
    handleNewObjective() {
      let goal = (this as any).currentGoal;
      let startDate = goal.startDate ? new Date(goal.startDate) : null;
      let endDate = goal.endDate ? new Date(goal.endDate) : null;
      let maxPriority = (this as any).allObjectives.length + 1;

      this.edittingObjective = {
        id: null,
        name: null,
        timeline: [startDate, endDate],
        priority: maxPriority,
        maxPriority: maxPriority,
        description: null,
        trackingQuestion: null,
        measurementUnit: null,
        targetType: null,
        inputOptions: '[{"label":"","placeholder":"Example: Yes","value":100},{"label":"","placeholder":"Example: No","value":0}]',
        trackingTarget: null,
        checkinDates: null,
        checkinTime: "09:00",
        cronExcludedDates: [],
        cronExpression: null,
        cronStartDate: null,
        cronEndDate: null,
        attachments: [],
        goalId: (this as any).currentGoal.id,
      };
      this.showObjectiveSetup = true;
    },
    handleCancelNewObjective() {
      this.showObjectiveSetup = false;
    },
    handleCardClick(objective, e) {
      this.quickEdittingObjective = objective;
      this.quickEdittingObjective.attachmentsForView = objective.attachments ? JSON.parse(objective.attachments) : [];
      this.getQuickEditorPosition(e.target.parentElement);
      this.showQuickEditor = true;
    },
    saveQuickEdittingObjective() {
      let context = this;
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;

      context.$store
        .dispatch("goal/upsertObjective", { data: context.quickEdittingObjective })
        .then((response) => {
          this.showQuickEditor = false;
        })
        .finally(() => {
          target.disabled = false;
        });
    },
    getQuickEditorPosition(element) {
      let offsetLeft = 0;
      let offsetTop = 0;
      do {
        if (!isNaN(element.offsetLeft)) {
          offsetLeft += element.offsetLeft - element.scrollLeft;
          offsetTop += element.offsetTop - element.scrollTop;
        }
      } while ((element = element.offsetParent));

      if (offsetLeft < 0) {
        offsetLeft = 0;
      }

      if (offsetTop < 0) {
        offsetTop = 0;
      }

      this.quickEditorStyles = {
        left: `${offsetLeft}px`,
        top: `${offsetTop}px`,
        position: "absolute",
      };
    },
    handleObjectiveEdit(objective, id) {
      if (!objective && id) {
        const objectives = (this as any).currentGoal.objectives || [];
        objective = objectives.find((o) => o.id === id);
      }

      let startDate = objective.startDate ? new Date(objective.startDate) : null;
      let endDate = objective.endDate ? new Date(objective.endDate) : null;

      let checkinDates = [];
      if (objective.checkinDates) {
        checkinDates = (objective.checkinDates as string).split(";").map((dateString) => {
          let values = dateString.split(",");
          return { date: values[0], target: values[1] };
        });
      }

      let maxPriority = (this as any).allObjectives.length;
      this.edittingObjective = {
        id: objective.id,
        name: objective.name,
        timeline: [startDate, endDate],
        priority: objective.priority,
        maxPriority: maxPriority,
        description: objective.description,
        trackingQuestion: objective.trackingQuestion,
        measurementUnit: objective.measurementUnit,
        targetType: objective.targetType,
        inputOptions: objective.inputOptions,
        trackingTarget: objective.trackingTarget,
        checkinDates: checkinDates,
        checkinTime: objective.checkinTime,
        cronExcludedDates: objective.cronExcludedDates,
        cronExpression: objective.cronExpression,
        cronStartDate: objective.cronStartDate,
        cronEndDate: objective.cronEndDate,
        attachments: objective.attachments ? JSON.parse(objective.attachments) : [],
        goalId: objective.goalId,
      };

      this.showQuickEditor = false;
      this.showObjectiveSetup = true;
    },
    handleObjectiveCopy(objective) {
      this.copyingObjective = {
        id: objective.id,
        name: objective.name,
        description: objective.description,
        goalId: objective.goalId,
      };

      this.showQuickEditor = false;
      this.showObjectiveCopy = true;
    },
    handleCancelObjectiveCopy() {
      this.showObjectiveCopy = false;
    },
    showDeleteDialog(element) {
      this.deleteElement = element;

      this.showQuickEditor = false;
      this.showDelete = true;
    },
    handleDelete() {
      let context = this;
      this.$store.dispatch("goal/deleteObjective", { data: this.deleteElement }).then((response) => {
        this.showDelete = false;
      });
    },
    getToValue(grades, index) {
      if (index + 1 < grades.length) {
        return grades[index + 1].from - 1;
      } else {
        return 100;
      }
    },
    handleTrackingFilter(filter) {
      var context = this as any;
      context.handleReportCardFilter();
    },
    handleValueFormatChanged(valueFormat) {
      var context = this as any;
      context.reportCardValueFormat = valueFormat;
    },
    handleAssignmentTrackingFilter(filter) {
      var context = this as any;
      context.viewType = filter.viewType;
      context.currentTrackerId = filter.trackerId;
    },
    handleReportCardFilter(filter) {
      (this as any).$refs.ReportCard.refreshReportData();
    },
    handleRefreshAssignments() {
      var context = this as any;
      context.$refs.OpenAssignments.refresh(context.currentTrackerId);
      context.$refs.CompletedAssignments.refresh(context.currentTrackerId);
    },
    handleVideoClick(type, url) {
      this.videoUrl = url;
      this.showVideoPlayer = true;
    },
    memberRoleNameResolver(memberId) {
      let members = (this as any).currentGoal ? (this as any).currentGoal.members.filter((m) => m.memberId == memberId) : [];
      if (members.length === 1) {
        let member = members[0];
        return member.role == 3 ? "Contributor" : member.role == 6 ? "Author & Contributor" : "";
      } else {
        return "";
      }
    },
  },
});
